export default __webpack_public_path__ + "static/media/cv-eliudcesar.abe7665b.pdf";